// #ux-redesign-start: shim que redirige /admin/profile → /admin/account?tab=profile
// Profile + Settings se fusionaron en /admin/account. Mantenemos esta ruta para
// no romper bookmarks externos ni redirects internos legacy.
import React from 'react';
import { Redirect } from 'react-router-dom';

const Profile = () => <Redirect to="/admin/account?tab=profile" />;

export default Profile;
// #ux-redesign-end
